import { Injectable, Optional, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@y42/core/dialog/confirm-dialog';
import { GitQuery } from '@y42/git';
import { UserQuery } from '@y42/user/state';
import { filter, tap } from 'rxjs';
import { GitCommitDialogComponent, GitCommitDialogData } from './git-commit-dialog/git-commit-dialog.component';
import { GitDisabledCommitDialogComponent } from './git-disabled-commit-dialog';

@Injectable({ providedIn: 'root' })
export class GitCommitHelper {
  constructor(
    private readonly dialog: MatDialog,
    private readonly gitQuery: GitQuery,
    private readonly userQuery: UserQuery,
    @Optional() private readonly vcRef: ViewContainerRef | null,
  ) {}

  checkForUncommittedChanges(): boolean {
    const modifiedFiles = this.gitQuery.getModifiedFilesList();
    const hasUncommittedChanges = modifiedFiles.length > 0;
    if (hasUncommittedChanges) {
      this.dialog
        .open(ConfirmDialogComponent, {
          width: '600px',
          data: {
            data: true,
            text: `You have uncommitted changes. Please commit them before executing merge`,
            confirmation_text: 'Commit',
            header_text: 'Uncommitted Changes',
          },
          panelClass: ['confirmation-pop-up'],
        })
        .afterClosed()
        .pipe(
          filter(Boolean),
          tap(() => this.openCommitDialog()),
        )
        .subscribe();
    }

    return hasUncommittedChanges;
  }

  openCommitDialog(data?: Omit<GitCommitDialogData, 'user'>) {
    const user = this.userQuery.getActiveUser();
    const config: MatDialogConfig<GitCommitDialogData> = {
      width: data?.forceCommit ? '100vw' : '90vw',
      height: data?.forceCommit ? '100vh' : '80vh',
      panelClass: ['full-screen-popup'],
      data: {
        ...(data || {}),
        user,
      },
      disableClose: data?.forceCommit ?? false,
      viewContainerRef: this.vcRef || undefined,
    };

    if (data?.forceCommit) {
      config.maxWidth = '100vw';
    }

    return this.dialog.open<GitCommitDialogComponent, GitCommitDialogData>(GitCommitDialogComponent, config);
  }

  openDisabledCommitDialog() {
    return this.dialog.open<GitDisabledCommitDialogComponent>(GitDisabledCommitDialogComponent, {
      width: '600px',
      disableClose: true,
    });
  }
}
